import axios, { AxiosError, AxiosResponse } from 'axios'
import { EClassifications } from '@Enum/classifications.enum'
import * as Redux from 'redux'
import { ToastServices } from '@Services/toast.service'
import { APIServices } from '@Services/api.service'
import { MClassification } from '@Models/classification.model'
import { ClientActionTypes } from '../client.action-types'

const CLASSIFICATIONS = `/admin/classifications`

const setClassifications = (type: EClassifications, data: any) => {
    return (dispatch: Redux.Dispatch) => {
        let actionType = ''
        const {
            MAKE,
            MODEL,
            SAFE_SUB_TYPE,
            SAFE_TYPE,
            COMPONENT,
            CONTACT_CATEGORY,
            CONTACT_TOPIC,
            ISSUE,
            SAFE_MAKE,
            SAFE_MODEL,
            STORAGE_TYPE,
        } = EClassifications
        switch (type) {
            case MAKE:
                actionType = ClientActionTypes.GET_MAKES
                break
            case MODEL:
                actionType = ClientActionTypes.GET_MODELS
                break
            case SAFE_TYPE:
                actionType = ClientActionTypes.GET_SAFE_TYPES
                break
            case SAFE_SUB_TYPE:
                actionType = ClientActionTypes.GET_SAFE_SUB_TYPES
                break
            case COMPONENT:
                actionType = ClientActionTypes.GET_COMPONENTS
                break
            case CONTACT_CATEGORY:
                actionType = ClientActionTypes.GET_CONTACT_CATEGORIES
                break
            case CONTACT_TOPIC:
                actionType = ClientActionTypes.GET_CONTACT_TOPICS
                break
            case ISSUE:
                actionType = ClientActionTypes.GET_ISSUE
                break
            case SAFE_MAKE:
                actionType = ClientActionTypes.GET_SAFE_MAKE
                break
            case SAFE_MODEL:
                actionType = ClientActionTypes.GET_SAFE_MODEL
                break
            case STORAGE_TYPE:
                actionType = ClientActionTypes.GET_STORAGE_TYPES
                break

            default:
                actionType = ''
                break
        }
        if (actionType) {
            dispatch({
                type: actionType,
                payload: data?.map(
                    (item: MClassification) => new MClassification(item)
                ),
            })
        }
    }
}

const getClassifications = (classType: EClassifications, queryParams?: any) => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        const headers = APIServices.publicHeader()
        const params = {
            // limit: 100,
            limit: 0,
            type: classType,
            status: 'ACTIVE',
            // parentId: queryParams?.parentId,
            parentCode: queryParams?.parentCode,
        }
        return new Promise((resolve, reject) => {
            axios
                .get(CLASSIFICATIONS, { params, headers })
                .then((res: AxiosResponse) => {
                    const { data } = res.data
                    dispatch(setClassifications(classType, data) as any)
                    resolve(res)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const getClassificationsBySuggestion = (queryParams?: any) => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        const headers = APIServices.publicHeader()
        const params = {
            // limit: 100,
            limit: 0,
            status: 'ACTIVE',
            ...queryParams,
        }
        return new Promise((resolve, reject) => {
            axios
                .get(`${CLASSIFICATIONS}/firearm-fields`, { params, headers })
                .then((res: AxiosResponse) => {
                    const { makes, calibers, models, safeTypes, safeSubTypes } =
                        res?.data?.data
                    const mappedMakes = makes?.map((item: any) => ({
                        value: item,
                        name: item,
                    }))

                    const mappedCalibers = calibers?.map((item: any) => ({
                        value: item,
                        name: item,
                    }))

                    const mappedModels = models?.map((item: any) => ({
                        value: item,
                        name: item,
                    }))

                    const mappedSafeTypes = safeTypes?.map((item: any) => ({
                        value: item,
                        name: item,
                    }))

                    const mappedSafeSubTypes = safeSubTypes?.map(
                        (item: any) => ({
                            value: item,
                            name: item,
                        })
                    )

                    const payload = {
                        makes: mappedMakes,
                        models: mappedModels,
                        // safeTypes: mappedSafeTypes,
                        // safeSubTypes: mappedSafeSubTypes,
                        calibers: mappedCalibers,
                    }

                    dispatch({
                        type: ClientActionTypes.GET_CLASSIFICATIONS_SUGGESTION,
                        payload,
                    })
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}
const ClassificationAction = {
    getClassifications,
    getClassificationsBySuggestion,
}

export default ClassificationAction
